module.exports = __webpack_public_path__ + "img/SimpleSearch.e44937ff.png";